export function downloadFile(filename, content, type) {
    const blob = new Blob([content], { type: 'text/plain' });
    const a = document.createElement('a');
    a.setAttribute('download', filename);
    a.setAttribute('href', window.URL.createObjectURL(blob));
    a.click();

    // const a = document.createElement('a');
    // a.setAttribute('href', `data:${type || 'text/plain'};charset=utf-8,` +encodeURIComponent(content));
    // a.setAttribute('download', filename);
    // a.style.display = 'none';
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
};